module.exports = __webpack_public_path__ + "img/like-red.ce84272e.svg";